import { Component, Input, ViewEncapsulation, ComponentFactoryResolver, ViewContainerRef, ViewChild, Renderer2, Output, EventEmitter, OnDestroy } from '@angular/core';
import { UserMessageRender } from './user-message-render/user-message-render.component';
import { AssessorMessageRender } from './assessor-message-render/assessor-message-render.component';
import { Subject ,  Subscription } from 'rxjs';
import { AppState } from '../../../interfaces/app-state.interface';
import { Store } from '@ngrx/store';
import { AutoUnsubscribe } from 'ngx-auto-unsubscribe';

@AutoUnsubscribe()
@Component({
    selector: 'conversation-assessor',
    templateUrl: 'conversation-assessor.component.html',
    styleUrls: ['conversation-assessor.component.scss'],
    encapsulation: ViewEncapsulation.None,
    entryComponents: [UserMessageRender, AssessorMessageRender]
})
export class ConversationAssessorComponent implements OnDestroy{

    private lastMessage: any = null; // armazena ultima msg enviada user|assessor
    private msgComponentRender: any = null; // component dinamico
    private timeToAttendance: any = null; // tempo entre o request success do chat e o atendimento de fato
    private userPhoto: any;
    private chatStateSubscription: Subscription;

    // status do ultimo assessor
    public assessorLastInformations: any = {
        status: null,
        name: null,
        customStatus: null
    };

    public chatStarted: boolean;
    private realName: string;
    private realNewAcessorName: string;
    private lastAcessorRealName: string;

    @Input() subject: string; // recebe o assunto do chat
    @Input() historic: Array<any>;
    @Output() endChatEmitter: EventEmitter<any> = new EventEmitter(); // emite um evento quando o chat é finalizado/encerrado/falha/erro/morre
    @ViewChild('container', { read: ViewContainerRef, static: true }) viewContainer: ViewContainerRef; // container para renderizar

    constructor(
        private factoryResolver: ComponentFactoryResolver,
        private viewContainerRef: ViewContainerRef,
        private store: Store<AppState>
    ) {

        this.chatStateSubscription = this.store.select(s => s.chat).subscribe(data => {
            if(data.pending) {
                this.userPhoto = data.acessorPhoto;
            }
        });

    }

    @Input() set message(message: any) {
        if (message) {
            switch (message.type) {
                case 'User':
                    this.createMessageComponent(UserMessageRender)
                        .setUserComponentData(message.message, message.id)
                        .postItMessage();
                    this.lastMessage = 'user';
                    break;
                case 'Assessor':
                    this.setAssessorComponentData(message.message)
                    break;
            }
        }
    }

    createMessageComponent(comp) {
        this.msgComponentRender = this.factoryResolver
            .resolveComponentFactory(comp)
            .create(this.viewContainerRef.parentInjector);
        return this;
    }

    postItMessage() {
        this.viewContainer.insert(this.msgComponentRender.hostView);
    }

    setUserComponentData(text, id = null) {
        this.msgComponentRender.instance.data = text;
        this.msgComponentRender.instance.id = id;
        return this;
    }

    setAssessorComponentData(data) {
        if(data && data.messages){
            data.messages.map((msg: any) => {
                this.assessorLastInformations.status = msg.type; // save last status assessor msg

                switch (msg.type) {
                    case 'ChatMessage':
                        this.createAssessorMsg({
                            type: 'message',
                            text: msg.message.text,
                            name: msg.message.name,
                        });
                        break;

                    case 'ChatRequestFail':
                        if(msg.message.reason == "Unavailable") {
                            this.createAssessorMsg({
                                type: 'message',
                                text: 'Nenhum assessor disponível no momento, por favor, tente mais tarde.',
                                status: msg.type
                            });
                        } else {
                            this.createAssessorMsg({
                                type: 'message',
                                text: 'Erro ao iniciar chat.',
                                status: msg.type
                            });
                        };
                        this.endChatEmitter.emit(true);
                        break;

                    case 'ChatEnded':
                        this.createAssessorMsg({
                            type: 'feedback',
                            name: this.assessorLastInformations.name,
                            status: msg.type
                        });
                        this.endChatEmitter.emit(true);
                        break;

                    case 'ChatRequestSuccess':
                        this.createAssessorMsg({
                            type: 'message',
                            text: 'Você será atendido em alguns minutos...',
                        });
                        break;

                    case 'ChatEstablished':
                        this.createAssessorMsg({
                            type: 'feedback',
                            name: msg.message.name,
                            status: msg.type
                        });
                        this.chatStarted = true;
                        break;

                    case 'ChatTransferred':
                        this.createAssessorMsg({
                            type: 'feedback',
                            name: this.assessorLastInformations.name,
                            newAssessorName: msg.message.name,
                            status: msg.type
                        });
                        break;

                    case 'ChatAlerts':
                        this.createAssessorMsg({
                            type: 'message',
                            text: msg.message.text,
                            status: msg.type
                        });
                        this.endChatEmitter.emit(true);
                        break;

                    case 'ChatMsg':
                        this.createAssessorMsg({
                            type: 'message',
                            text: msg.message.text,
                            status: msg.type
                        });
                        break;

                    case 'CustomEvent':
                        this.assessorLastInformations.customEvent = msg.message;
                        break;

                    default:
                        break;
                }
            });
        }
    }

    /**
     * Renderiza a mensagem do assessor.
     *
     * @param params texto a ser renderizado na msg
     */
    createAssessorMsg(params: any) {
        setTimeout(() => {

            // create component
            this.createMessageComponent(AssessorMessageRender);

            // msg type (API type)
            this.msgComponentRender.instance.type = params.type;

            // last msg render (type)
            this.msgComponentRender.instance.lastMessage = this.lastMessage;

            // set msg text
            this.msgComponentRender.instance.text = (params.hasOwnProperty('text')) ? params.text : '';
            //replace names
            if(this.realName){
                this.msgComponentRender.instance.text = this.msgComponentRender.instance.text.replace(new RegExp(this.realName, 'gi'), this.normalizeName(this.realName) );
            }
            if(this.realNewAcessorName){
                this.msgComponentRender.instance.text = this.msgComponentRender.instance.text.replace(new RegExp(this.realNewAcessorName, 'gi'), this.normalizeName(this.realNewAcessorName) );
            }
            if(this.lastAcessorRealName){
                this.msgComponentRender.instance.text = this.msgComponentRender.instance.text.replace(new RegExp(this.lastAcessorRealName, 'gi'), this.normalizeName(this.lastAcessorRealName) );
            }


            // set assessor name
            this.msgComponentRender.instance.name = (params.hasOwnProperty('name')) ? this.normalizeName(params.name) : null;
            this.realName = params.hasOwnProperty('name')? params.name : this.realName;

            // confere se é um novo assessor enviando msg
            this.msgComponentRender.instance.status = (params.hasOwnProperty('status')) ? params.status : null;

            // novo assessor na conversa
            this.msgComponentRender.instance.newAssessorName = (params.hasOwnProperty('newAssessorName')) ? this.normalizeName(params.newAssessorName) : null;
            this.realNewAcessorName = params.hasOwnProperty('newAssessorName')? params.newAssessorName : this.realNewAcessorName;

            // salva o nome do ultimo assessor
            this.assessorLastInformations.name = (params.hasOwnProperty('name')) ? this.normalizeName(params.name) : this.assessorLastInformations.name;
            this.lastAcessorRealName = params.hasOwnProperty('name')? params.name : this.lastAcessorRealName;

            // post
            this.postItMessage();
            this.lastMessage = params.type;
        }, 800);
    }

    /**
     * Normaliza um nome (primeiro e segundo)
     * @param name nome completo
     */
    private normalizeName(name: string):string{
        const parts = name.split(' ');

        if(parts.length <= 1){
            return name;
        }
        return `${parts[0]} ${parts[1]}`;

    }

    //não remover, necessário para o funcionamento correto do @AutoUnsubscribe
    ngOnDestroy() { }
}
